import { CircularProgress, Paper, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import useNumberFormatter from "../../../hooks/useNumberFormatter";
import { useTutorialContext } from "../TutorialContext";

export default function GlobalMenu() {
    const formatter = useNumberFormatter();

    const { tutorials, activeStep } = useTutorialContext();

    const activeStepData = useMemo(
        () => tutorials.find((s) => s.step === activeStep),
        [tutorials, activeStep]
    );

    const progress = useMemo(() => {
        const progress =
            (tutorials.indexOf(tutorials.find((s) => s.step === activeStep)) /
                (tutorials.length - 1)) *
            100;

        return Math.round(progress * 10) / 10;
    }, [tutorials, activeStep]);

    return (
        <Paper
            sx={{
                margin: 0,
                position: "fixed",
                top: "20px",
                right: "20px",
                width: "300px",
                zIndex: 100000,
                height: "120px",
                boxSizing: "border-box",
                border: "none",
                backgroundColor: "primary.main",
                color: "white",
            }}
        >
            <Stack
                sx={{ height: "100%" }}
                direction="row"
                alignItems="center"
                spacing={2}
            >
                <Stack
                    className="progress-bar"
                    alignItems="center"
                    sx={{ position: "relative", paddingLeft: 1 }}
                >
                    <CircularProgress
                        size={80}
                        value={progress}
                        variant="determinate"
                        color="error"
                    />

                    <Typography
                        variant="body1"
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        {formatter.format(progress)}%
                    </Typography>
                </Stack>
                <Stack className="level-description">
                    <Typography variant="h6">راهنمای کار با پنل</Typography>
                    <Typography variant="body1">اصول اولیه‌ی لازم:</Typography>
                    <Typography variant="body1">
                        مسیر را برای‌تان ساده کرده‌ایم
                    </Typography>
                </Stack>
            </Stack>
        </Paper>
    );
}
